import { ShieldCheck } from 'lucide-react'
import { Button, Modal } from '@/components/ui'

interface AnalyticsConsentModalProps {
  abierto: boolean
  onAceptar: () => void
  onRechazar: () => void
}

export function AnalyticsConsentModal({
  abierto,
  onAceptar,
  onRechazar,
}: AnalyticsConsentModalProps) {
  return (
    <Modal
      abierto={abierto}
      onCerrar={onRechazar}
      tamano="md"
      sinCerrarAlClickFuera
    >
      <div className="space-y-5">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-teal-500/25 bg-teal-500/10 text-teal-300">
            <ShieldCheck className="h-5 w-5" />
          </div>
          <div>
            <h2 className="text-base font-semibold text-white">
              Ayúdanos a mejorar RadCore durante la beta
            </h2>
            <p className="mt-2 text-sm leading-6 text-slate-400">
              Podemos registrar analíticas de uso y sesiones de navegación enmascaradas para entender dónde se traban los usuarios y corregir errores.
            </p>
          </div>
        </div>

        <div className="rounded-lg border border-white/[0.07] bg-white/[0.03] p-3 text-sm leading-6 text-slate-400">
          No registramos contraseñas ni contenido de reportes clínicos en las grabaciones. Los campos de texto y el texto visible se enmascaran antes de enviarse a PostHog.
        </div>

        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <Button type="button" variante="ghost" onClick={onRechazar}>
            Ahora no
          </Button>
          <Button type="button" variante="primary" onClick={onAceptar}>
            Acepto participar
          </Button>
        </div>
      </div>
    </Modal>
  )
}
